import { ReactNode } from 'react';

import { ConfigHelper, Feature } from '@devxdiscover/devhub-common';

/**
 * ConfigFeatureProps is the props interface for ConfigFeatureCheck.
 */
export type ConfigFeatureProps = { children: ReactNode } & { feature: Feature };

/**
 * ConfigFeatureCheck is a React component that renders its children only if the feature is enabled.
 * @param props  The props for ConfigFeatureCheck.
 * @constructor
 */
export const ConfigFeatureCheck = (props: ConfigFeatureProps) => {
  const { children, feature } = props;
  const enabled = ConfigHelper.instance.isFeatureEnabled(feature);
  return <>{enabled ? children : null}</>;
};

/**
 * ConfigIsCableEntity is a React component that renders its children only if the entity is a cable entity.
 */
export type ConfigIsCableEntityProps = { children: ReactNode } & {
  corporateEntity: string;
};

/**
 * ConfigIsCableEntityProps is the props interface for ConfigIsCableEntity.
 * @param props  The props for ConfigIsCableEntity.
 * @param props.corporatEntity  The corporate entity to check.
 * @constructor
 */
export const ConfigIsCableEntity = (props: ConfigIsCableEntityProps) => {
  const { children, corporateEntity } = props;
  const enabled = corporateEntity === 'Cable';
  return <>{enabled ? children : null}</>;
};
